import { render, staticRenderFns } from "./LexonAutocompleteComponent.vue?vue&type=template&id=31755854&scoped=true&lang=pug"
import script from "./LexonAutocompleteComponent.vue?vue&type=script&lang=ts"
export * from "./LexonAutocompleteComponent.vue?vue&type=script&lang=ts"
import style0 from "./LexonAutocompleteComponent.vue?vue&type=style&index=0&id=31755854&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31755854",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31755854')) {
      api.createRecord('31755854', component.options)
    } else {
      api.reload('31755854', component.options)
    }
    module.hot.accept("./LexonAutocompleteComponent.vue?vue&type=template&id=31755854&scoped=true&lang=pug", function () {
      api.rerender('31755854', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/fields/LexonAutocomplete/LexonAutocompleteComponent.vue"
export default component.exports